
import {
  computed, PropType, defineComponent, toRefs
} from 'vue';
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import TagDisplay from '@/components/tagging/TagDisplay.vue';
import { UserCarouselUser } from './userCarousel.types';

const SUMMARY_LIMIT = 174;

export default defineComponent({
  name: 'LPUserCard',
  components: {
    BCXAvatar,
    TagDisplay
  },
  props: {
    user: {
      type: Object as PropType<UserCarouselUser>,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props) {
    const { user } = toRefs(props);

    const truncatedSummary = computed(() => {
      const summary = user.value.summary ?? '';

      if (summary.length <= SUMMARY_LIMIT) {
        return summary;
      }

      return `${summary.slice(0, SUMMARY_LIMIT).trimEnd()}...`;
    });

    const displayedSkills = computed(() => user.value.skills.slice(0, 5));

    return {
      displayedSkills,
      truncatedSummary
    };
  }
});
